import {Address} from "../shared/address";
import {AddressTypes} from "../shared/address-types";
import {BaseEntity} from "./base-entity";
import {Telephone} from "../shared/telephone";

export class Contact extends BaseEntity{

    id : number;
    address: Address[] = [];
    contactName: ContactName;
    firmName : string;
    companyName : string;
    legalFirmName : string;
    parentOrganizationName : string;
    email : string;
    displayName : string;
    organizationName : string;
    contactType : string;
    telephone : Telephone[] = [];
    legalFirmId : number;

    constructor(contact?: Contact) {
        super(contact);
        if (contact) {

            this.contactName = new ContactName(contact.contactName);
            this.address = [];
            if (Array.isArray(contact.address)) {
                for (let i: number = 0; i < contact.address.length; i++) {
                    this.address[i] = new Address(contact.address[i]);
                }
            }

            this.telephone = [];
            if(Array.isArray(contact.telephone)) {
                for(let j : number = 0; j < contact.telephone.length; j++) {
                    this.telephone[j] = new Telephone(contact.telephone[j]);
                }
            }
        }
    }

    get mailingAddress() : Address {
        return this.address.find( item => item.addressTypeCode === AddressTypes.mailing)
    }


    //Full name should handle the logic of displaying name in different formats based on the contact type.
    //For now it handles guarantor organization & person, going forward the logic for other contact types should be also added here.
    get fullName() : string {
        switch(this.contactType) {
            case 'TRANSFEROR_ORGANIZATION':
            case 'GUARANTOR_ORGANIZATION':
            case 'PRIVATE_CONTACT_ORGANIZATION':
                return this.organizationName ? this.organizationName : '';
            default:
                return this.contactName ? this.contactName.fullName : '';
        }
    }

    getPhone(type : string) : Telephone {
        if(!this.telephone) {
            this.telephone = [];
        }

        let phone : Telephone = this.telephone.find((t : Telephone) => t.phoneTypeCode === type);
        if(!phone) {
            phone = new Telephone();
            phone.phoneTypeCode = type;
            this.telephone.push(phone);
        }
        return phone;
    }
}

export class ContactName  {

    constructor(contactName?: ContactName) {
        if (contactName) {
            for (let prop in contactName) {
                if (contactName.hasOwnProperty(prop)) {
                    this[prop] = contactName[prop];
                }
            }
        }
    }

    id: number;
    firstName: string;
    middleName: string;
    lastName: string;


    get fullName(): string {
        let fullNameStr = (this.lastName ? this.lastName  + ', ' : '') +
            (this.firstName ? this.firstName  + ' ' : '' ) +
            (this.middleName ? this.middleName : '');
        return fullNameStr ? fullNameStr.trim() : '';
    }

}
